/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ServerErr {
    WRITE_FILE_FAILED = 'WRITE_FILE_FAILED',
    NOT_OWNED_GAME = 'NOT_OWNED_GAME',
    ID_INVALID = 'ID_INVALID',
    LAST_VERSION_NOT_APPROVED = 'LAST_VERSION_NOT_APPROVED',
    ADMIN_NOT_EXISTS = 'ADMIN_NOT_EXISTS',
    VERSION_PROCESSED = 'VERSION_PROCESSED',
    FILE_NOT_FOUND = 'FILE_NOT_FOUND',
    PERMISSION_DENIED = 'PERMISSION_DENIED',
    ADMIN_DOMAIN_EXISTS = 'ADMIN_DOMAIN_EXISTS',
    ADMIN_TICKET_EXPIRED = 'ADMIN_TICKET_EXPIRED',
    VALIDATE_ERR = 'VALIDATE_ERR',
}
